import React from "react";

const ArrowDownSmall = () => (
<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.898438 7L5.75219 11.8538L10.6059 7" stroke="#000" strokeWidth="1.5"/>
<path d="M5.75 10.6735L5.75 0.355469" stroke="#000" strokeWidth="1.5"/>
</svg>
);

export default ArrowDownSmall;
